module.exports = __webpack_public_path__ + "img/lea-39.7e2864cd.png";